import { Component, OnInit, Output, Input, ViewChild, EventEmitter, TemplateRef, HostBinding, Optional, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { FormGroup, FormControl } from '@angular/forms';
import { AssignPerformerConfig } from './assign-performer-config.entity';
import { OrganizationPotentialOwner, ActionScope, OrganizationLevel } from '../organization-potential-owner/actionOrganizationScope';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-assign-performer-config',
  templateUrl: './assign-performer-config.component.html',
  styleUrls: ['./assign-performer-config.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class AssignPerformerConfigComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();
  assingPerformerConfigForm: FormGroup;
  private config: AssignPerformerConfig;

  @Input()
  set value(v: AssignPerformerConfig) {
    this.assingPerformerConfigForm = new FormGroup({
      multiSelect: new FormControl(v.multiSelect),
      necessary: new FormControl(v.necessary)
    });
    this.operator = v.operator || 'currentUser';
    this.allowGlobalAssign = v.allowGlobalAssign || false;
    if (v.assignScope) {
      this.organizationLevel = v.assignScope.organizationLevel;
      this.includeChildren = v.assignScope.includeChildren;
    }
  }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  allowGlobalAssign = false;

  operatorCollection = [
    { text: this.localePipe.transform('component.assignPerformer.currentUser'), value: 'currentUser' },
    { text: this.localePipe.transform('component.assignPerformer.procInstCreator'), value: 'procInstCreator' }];
  operator = 'currentUser';

  organizationLevelCollection = [
    { value: 'GLOBAL', text: this.localePipe.transform('component.assignPerformer.global'), orgId: 'global' },
    { value: 'UNIT', text: this.localePipe.transform('component.assignPerformer.currentUnit'), orgId: 'currentUnit' },
    { value: 'DEPARTMENT', text: this.localePipe.transform('component.assignPerformer.currentDepartment'), orgId: 'currentDepartment' }];
  organizationLevel = this.organizationLevelCollection[0].value;
  includeChildren = false;

  modalConfig = {
    title: this.localePipe.transform('component.assignPerformer.assignPerformer'),
    width: 720,
    height: 490,
    showButtons: true
  };
  constructor(
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  clickOK() {
    this.config = {
      operator: this.operator,
      multiSelect: this.assingPerformerConfigForm.get('multiSelect').value,
      necessary: this.assingPerformerConfigForm.get('necessary').value,
      allowGlobalAssign: this.allowGlobalAssign
    };
    if (this.allowGlobalAssign && this.organizationLevel !== this.organizationLevelCollection[0].value) {
      const potential = new OrganizationPotentialOwner();
      potential.actionScope = ActionScope.AssignUser;
      potential.organizationLevel = this.organizationLevel as OrganizationLevel;
      potential.organizationId = this.organizationLevelCollection.find(o => o.value === this.organizationLevel).orgId;
      potential.organizationName = this.organizationLevelCollection.find(o => o.value === this.organizationLevel).text;
      potential.includeChildren = this.includeChildren;
      potential.tag = 'variable';
      this.config.assignScope = potential;
    }
    const object = { value: this.config, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  valueChange(event: any) {
    switch (event.value) {
      case this.organizationLevelCollection[0].value:
        this.includeChildren = false;
        break;
      case this.organizationLevelCollection[1].value:
        this.includeChildren = true;
        break;
      case this.organizationLevelCollection[2].value:
        this.includeChildren = false;
        break;
    }
  }
}
export class AssignConfigConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data): string {
    return this.localePipe.transform('component.assignPerformer.set');
  }
}
